import React, { Component } from "react";
import {
  Container,
  Form,
  Row,
  Col,
  Button,
  Tab,
  Tabs,
  Card,
  Modal,
  Table,
  ButtonGroup
} from "react-bootstrap";
import Timekeeper from "react-timekeeper";
import Stepper from "react-stepper-horizontal";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { appConfig } from "../../config";
import Navbar from "../../components/Navbar/Navbar";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng
} from "react-places-autocomplete";
import TimePicker from "react-time-picker";
import "./profileupdate.css";
import { node } from "prop-types";

//import Map from "./Map.js";
//import Geocode from "react-geocode";
//Geocode.setApiKey("AIzaSyClgxbuJbMMe7Pl6eoKZIX_lTFY8RbRK7o");

class UpdateProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: true,

      steps: [
        { title: "Business Details" },
        { title: "Location" },
        { title: "Working days" },
        { title: "Bank Details" }
      ],
      currentstep: 0,

      orgname: "",
      weburl: "",
      storeEmail: "",
      mobile: "",
      licencenum: "",
      licencenum2: "",
      gst: "",
      contPerson: "",
      fileImg: "",
      file: "",
      credit: "",
      homedelivery: false,

      location: "",
      lat: "",
      longi: "",
      addr1: "",
      addr2: "",
      landmark: "",
      city: "",
      zip: "",
      states: "",
      district: "",

      workingHrs: {
        mon: {
          isWorking: false,
          open: "09:00",
          close: "18:00",
          openmin: 540,
          closemin: 1080,
          showDay: "Monday"
        },
        tue: {
          isWorking: false,
          open: "09:00",
          close: "18:00",
          openmin: 540,
          closemin: 1080,
          showDay: "Tuesday"
        },
        wed: {
          isWorking: false,
          open: "09:00",
          close: "18:00",
          openmin: 540,
          closemin: 1080,
          showDay: "Wednesday"
        },
        thu: {
          isWorking: false,
          open: "09:00",
          close: "18:00",
          openmin: 540,
          closemin: 1080,
          showDay: "Thursday"
        },
        fri: {
          isWorking: false,
          open: "09:00",
          close: "18:00",
          openmin: 540,
          closemin: 1080,
          showDay: "Friday"
        },
        sat: {
          isWorking: false,
          open: "09:00",
          close: "18:00",
          openmin: 540,
          closemin: 1080,
          showDay: "Saturday"
        },
        sun: {
          isWorking: false,
          open: "09:00",
          close: "18:00",
          openmin: 540,
          closemin: 1080,
          showDay: "Sunday"
        }
      },

      duplicateworkingHrs: {
        mon: {},
        tue: {},
        wed: {},
        thu: {},
        fri: {},
        sat: {},
        sun: {}
      },

      bankName: "",
      acholderName: "",
      acType: "",
      acNo: "",
      ifsc: "",
      branchName: "",
      branchAddr: "",

      orgnameError: "",
      storeEmailError: "",
      mobileError: "",
      licencenumError: "",
      licencenum2Error: "",
      gstError: "",
      contPersonError: "",
      addr1Error: "",
      cityError: "",
      statesError: "",
      districtError: "",
      zipError: "",
      bankNameError: "",
      acholderNameError: "",
      acTypeError: "",
      acNoError: "",
      ifscError: "",
      branchNameError: "",
    };
  }

  componentDidMount() {
    if ("geolocation" in navigator) {
      console.log("Available");
    } else {
      console.log("Not Available");
    }

    let user = JSON.parse(localStorage.getItem("userDetails"));
    console.log(user);

    this.props.fetchStates();
    this.props.fetchbanks();
  }

  //For closing the modal box
  closeModal = () => {
    document.getElementById("overlayDiv").style.display = "none";
    this.setState({
      ...this.state,
      showModal: false
    });
  };

  onChange = e => {
    let val = e.target.value;
    let name = e.target.name;

    if (name === "orgName") {
      this.setState({
        ...this.state,
        orgname: val,
        orgnameError: ""
      });
    } else if (name === "licenceNum") {
      this.setState({
        ...this.state,
        licencenum: val,
        licencenumError: ""
      });
    }
    else if (name === "licenceNum2") {
      this.setState({
        ...this.state,
        licencenum2: val,
        licencenum2Error: ""
      });
    } else if (name === "webSite") {
      this.setState({
        ...this.state,
        weburl: val
      });
    } else if (name === "storeEmail") {
      this.setState({
        ...this.state,
        storeEmail: val,
        storeEmailError: ""
      });
    } else if (name === "contPerson") {
      this.setState({
        ...this.state,
        contPerson: val,
        contPersonError: ""
      });
    } else if (name === "mobile") {
      this.setState({
        ...this.state,
        mobile: val,
        mobileError: ""
      });
    } else if (name == "addr2") {
      this.setState({
        ...this.state,
        addr2: val
      });
    } else if (name === "homedel") {
      this.setState({
        ...this.state,
        homedelivery: val,
      })
    } else if (name === "landmark") {
      this.setState({
        ...this.state,
        landmark: val
      });
    } else if (name === "city") {
      this.setState({
        ...this.state,
        city: val,
        cityError: "",
      });
    } else if (name === "zip") {
      this.setState({
        ...this.state,
        zip: val,
        zipError: "",
      });
    } else if (name === "states") {
      this.setState(
        {
          ...this.state,
          states: val,
          statesError: "",
        },
        () => {
          this.props.fetchDistricts(val);
        }
      );
    } else if (name === "district") {
      // alert(val);
      this.setState({
        ...this.state,
        district: val,
        districtError: "",
      });
    } else if (name === "credit") {
      // alert(val);
      this.setState({
        ...this.state,
        credit: val
      });
    } else if (name === "gstin") {
      this.setState({
        ...this.state,
        gst: val,
        gstError: ""
      });
    } else if (name === "banks") {
      this.setState({
        ...this.state,
        bankName: val,
        bankNameError: "",
      });
    } else if (name === "acholderName") {
      this.setState({
        ...this.state,
        acholderName: val,
        acholderNameError: ""
      });
    } else if (name === "actype") {
      this.setState({
        ...this.state,
        acType: val,
        acTypeError: "",
      });
    } else if (name === "acno") {
      this.setState({
        ...this.state,
        acNo: val,
        acNoError: ""
      });
    } else if (name === "ifsc") {
      this.setState({
        ...this.state,
        ifsc: val,
        ifscError: "",
      });
    } else if (name === "branchname") {
      this.setState({
        ...this.state,
        branchName: val,
        branchNameError: ""
      });
    } else if (name === "branchaddr") {
      this.setState({
        ...this.state,
        branchAddr: val
      });
    }
  };

  ontimeChange = (val, day, status, inMinutes) => {
    //For conversion to minutes
    let hours = val.substring(0, 2);
    let min = val.substring(3, 5);
    let timeinMinutes = +(hours * 60) + +min; //Using unary plus operators to avoid concatenation;

    this.setState(
      prevState => ({
        ...prevState,
        workingHrs: {
          ...prevState.workingHrs,
          [day]: {
            ...prevState.workingHrs[day],
            [status]: val,
            [inMinutes]: timeinMinutes
          }
        },
      }),
    );
  };

  oncheckChange = (e, day) => {
    let isChecked = e.target.checked;

    this.setState(
      prevState => ({
        ...prevState,
        workingHrs: {
          ...prevState.workingHrs,
          [day]: {
            ...prevState.workingHrs[day],
            isWorking: isChecked
          }
        }
      }),
    );
  };

  //Related to the placesautocomplete plugin
  handleSelect = async value => {
    const results = await geocodeByAddress(value);
    const latLng = await getLatLng(results[0]); //For fetching thecoordinates

    this.setState({
      ...this.state,
      location: value,
      flag: 1,
      locationError: "",
      addr1: results[0].formatted_address,
      lat: latLng.lat,
      longi: latLng.lng,
    });
  };

  onLocationChange = value => {
    this.setState({
      ...this.state,
      location: value,
      flag: 0,
      addr1: value,
      addr1Error: "",
    });
  };

  validatebusiness = () => {
    const {
      orgname,
      storeEmail,
      mobile,
      licencenum,
      licencenum2,
      gst,
      contPerson,
    } = this.state;
    let isError = false;

    let regex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    let gstregex = (/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/);
    let mobreg = (/^[0-9]{10}$/);
    let namereg = (/^[a-zA-Z]/);

    const errmsg = "This field cannot be empty";
    const errmsg1 = "Please enter a valid email";
    const errmsg2 = "Entered GST is not in valid format";
    const errmsg3 = "Please enter a valid mobile number";
    const errmsg4 = "Please enter a name";

    const errors = {
      orgnameError: "",
      storeEmailError: "",
      mobileError: "",
      licencenumError: "",
      licencenum2Error: "",
      gstError: "",
      contPersonError: "",
    };

    if (orgname === "") {
      isError = true;
      errors.orgnameError = errmsg;
    }
    if (storeEmail === "") {
      isError = true;
      errors.storeEmailError = errmsg;
    }
    if (this.state.storeEmail !== "" && !regex.test(this.state.storeEmail)) {
      isError = true;
      errors.storeEmailError = errmsg1;
    }
    if (mobile === "") {
      isError = true;
      errors.mobileError = errmsg;
    }
    if (mobile !== "" && !mobreg.test(mobile)) {
      isError = true;
      errors.mobileError = errmsg3;
    }
    if (licencenum === "") {
      isError = true;
      errors.licencenumError = errmsg;
    }
    if (licencenum2 === "") {
      isError = true;
      errors.licencenum2Error = errmsg;
    }
    if (gst === "") {
      isError = true;
      errors.gstError = errmsg;
    }
    if (gst !== "" && !gstregex.test(gst)) {
      isError = true;
      errors.gstError = errmsg2;
    }
    if (contPerson === "") {
      isError = true;
      errors.contPersonError = errmsg;
    }
    if (contPerson !== "" && !namereg.test(contPerson)) {
      isError = true;
      errors.contPersonError = errmsg4;
    }

    this.setState({
      ...this.state,
      ...errors
    });

    return isError;
  };

  validatelocation = () => {
    const {
      addr1,
      city,
      states,
      district,
      zip
    } = this.state;

    let isError = false;

    let zipreg = (/^[0-9]{6}$/);

    const errmsg = "Please select a location";
    const errmsg3 = "Please enter a city";
    const errmsg1 = "Please select a state";
    const errmsg2 = "Please select a district";
    const errmsg4 = "This field can't be empty";
    const errmsg5 = "Enter a valid pincode";

    const errors = {
      addr1Error: "",
      cityError: "",
      statesError: "",
      districtError: "",
      zipError: "",
      locationError: "",
    };

    if (addr1 === "") {
      isError = true;
      errors.addr1Error = errmsg;
    }
    if (city === "") {
      isError = true;
      errors.cityError = errmsg3;
    }
    if (states === "") {
      isError = true;
      errors.statesError = errmsg1;
    }
    if (district === "") {
      isError = true;
      errors.districtError = errmsg2;
    }
    if (zip === "") {
      isError = true;
      errors.zipError = errmsg4;
    }
    if (zip !== "" && !zipreg.test(zip)) {
      isError = true;
      errors.zipError = errmsg5;
    }
    if (this.state.flag === 0) {
      isError = true;
      errors.locationError = errmsg;
    }

    this.setState({
      ...this.state,
      ...errors
    });

    return isError;
  };

  validatebank = () => {
    const {
      bankName,
      acholderName,
      acType,
      acNo,
      ifsc,
      branchName,
    } = this.state;

    let isError = false;

    let regac = (/^\d{9,18}$/);

    const errmsg = "This field is mandatory";
    const errmsg1 = "Please enter a valid account number";

    const errors = {
      bankNameError: "",
      acholderNameError: "",
      acTypeError: "",
      acNoError: "",
      ifscError: "",
      branchNameError: "",
    };

    if (bankName === "") {
      isError = true;
      errors.bankNameError = errmsg;
    }
    if (acholderName === "") {
      isError = true;
      errors.acholderNameError = errmsg;
    }
    if (acType === "") {
      isError = true;
      errors.acTypeError = errmsg;
    }
    if (acNo === "") {
      isError = true;
      errors.acNoError = errmsg;
    }
    if (acNo !== "" && !regac.test(acNo)) {
      isError = true;
      errors.acNoError = errmsg1;
    }
    if (ifsc === "") {
      isError = true;
      errors.ifscError = errmsg;
    }
    if (branchName === "") {
      isError = true;
      errors.branchNameError = errmsg;
    }

    this.setState({
      ...this.state,
      ...errors
    });

    return isError;
  };

  gotobusinesspage = () => {
    document.getElementById("businessdiv").style.display = "block";
    document.getElementById("locationdiv").style.display = "none";
    document.getElementById("workingdiv").style.display = "none";
    document.getElementById("bankdiv").style.display = "none";
    this.setState({
      ...this.state,
      currentstep: 0
    });
  };

  gotoLocationpage = () => {
    const validate1 = this.validatebusiness();

    if (!validate1) {
      document.getElementById("businessdiv").style.display = "none";
      document.getElementById("locationdiv").style.display = "block";
      document.getElementById("workingdiv").style.display = "none";
      document.getElementById("bankdiv").style.display = "none";
      this.setState({
        ...this.state,
        currentstep: 1
      });
    }
  };

  gotoWorkingdays = () => {
    const validate2 = this.validatelocation();

    if (!validate2) {
      document.getElementById("businessdiv").style.display = "none";
      document.getElementById("locationdiv").style.display = "none";
      document.getElementById("workingdiv").style.display = "block";
      document.getElementById("bankdiv").style.display = "none";
      this.setState({
        ...this.state,
        currentstep: 2
      });
    }
  };

  gotoBanking = () => {
    document.getElementById("businessdiv").style.display = "none";
    document.getElementById("locationdiv").style.display = "none";
    document.getElementById("workingdiv").style.display = "none";
    document.getElementById("bankdiv").style.display = "block";
    this.setState({
      ...this.state,
      currentstep: 3
    });
  };

  updateprofilevalues = async () => {
    await Object.keys(this.state.workingHrs).map((item, i) => (
      (this.state.workingHrs[item].isWorking) &&
      (
        this.setState(prevState => ({
          duplicateworkingHrs: {
            ...prevState.duplicateworkingHrs,
            [item]: {
              ...prevState.duplicateworkingHrs[item],
              "open": prevState.workingHrs[item].openmin,
              "close": prevState.workingHrs[item].closemin,
            }
          }
        }),
          () => { })
      )
    ));
    this.sendData();
  };

  sendData = () => {
    let geo =
      this.state.lat && this.state.longi
        ? [this.state.longi, this.state.lat]
        : [];

    const data = {
      orgname: this.state.orgname,
      licenceNo: this.state.licencenum,
      licenceNo2: this.state.licencenum2,
      weburl: this.state.weburl,
      storeEmail: this.state.storeEmail,
      contPerson: this.state.contPerson,
      mobile: this.state.mobile,
      file: this.state.file,
      addr1: this.state.addr1,
      addr2: this.state.addr2,
      landmark: this.state.landmark,
      city: this.state.city,
      zip: this.state.zip,
      district: this.state.district,
      states: this.state.states,
      credit: this.state.credit ? this.state.credit : 0,
      geo: geo,
      gstin: this.state.gst,
      bankName: this.state.bankName,
      acholderName: this.state.acholderName,
      acType: this.state.acType,
      acNo: this.state.acNo,
      ifsc: this.state.ifsc,
      branchName: this.state.branchName,
      branchAddr: this.state.branchAddr,
      workingHrs: this.state.duplicateworkingHrs,
    };

    const validate3 = this.validatebank();
    if (!validate3) {
      this.props.createOrgProfile(data);
    }
  };

  uploadSingleFile = e => {
    this.setState({
      // file: URL.createObjectURL(e.target.files[0])
      fileImg: URL.createObjectURL(e.target.files[0]),
      file: e.target.files[0]
    });
  };

  render() {
    //console.log(this.props.banks);
    let user = JSON.parse(localStorage.getItem("userDetails"));

    let districtList = this.props.districts && this.props.districts;
    let imgPreview;
    if (this.state.fileImg) {
      imgPreview = <img src={this.state.fileImg} alt="" />;
    }
    return (
      <div>
        <Navbar></Navbar>
        <Modal
          show={this.state.showModal}
          size="lg"
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body style={{ textAlign: "center" }}>
            <h4 style={{ fontWeight: "bold", color: "rgba(183, 51, 55, 1)" }}>
              Please provide us with some details, which is required to proceed
              further{" "}
            </h4>
            <Button
              style={{ backgroundColor: "#1768b7", marginTop:"10px" }}
              onClick={this.closeModal}
            >
              Continue
            </Button>
          </Modal.Body>
        </Modal>

        <div id="overlayDiv"></div>
        <div>
          <Stepper
            steps={this.state.steps}
            activeStep={this.state.currentstep}
            activeColor="#1768b7"
            completeColor="#1768b7"
            completeBarColor="#1768b7"
          />
        </div>

        <div id="businessdiv" className="updateprofilediv">
          <Card className="updateprofilecard">
            <Card.Header className="updateprofilehd" style={{backgroundColor:"#1768b7 !important"}}>
              <Form>
                <Row>
                  <Col xs={6} sm={6} md={3} lg={3}>
                    <Row style={{alignItems:"center"}}>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <Form.Group>
                          <img
                            src={
                              this.state.fileImg
                                ? this.state.fileImg
                                : require("../../assets/img/userImg.png")
                            }
                            style={{
                              height: 50,
                              width: 500,
                            
                              borderRadius: "50%"
                            }}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={6} sm={6} md={6} lg={6}>
                        <Form.Group>
                          <Form.File
                            style={{ width: "90px" }}
                            id="exampleFormControlFile1"
                            name="img"
                            type="file"
                            accept="image/*"
                            onChange={this.uploadSingleFile}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Form>
            </Card.Header>

            <Card.Body>
              <div>
                <hr  style={{backgroundColor:"#e4e5e6"}}/>
              </div>
              <Form>
                <Row>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <Form.Group controlId="orgName">
                      <Form.Label> Organization Name </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="orgName"
                        onChange={this.onChange}
                        value={this.state.orgname}
                      />
                      <div className="errStyle" style={{ float: "left" }}>
                        {this.state.orgnameError}
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <Form.Group controlId="webSite">
                      <Form.Label> Website </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="webSite"
                        onChange={this.onChange}
                        value={this.state.weburl}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <Form.Group controlId="storemail">
                      <Form.Label> Email ID </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="storeEmail"
                        onChange={this.onChange}
                        value={this.state.storeEmail}
                      />
                      <div className="errStyle" style={{ float: "left" }}>
                        {this.state.storeEmailError}
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <Form.Group controlId="mobile">
                      <Form.Label> Contact Number </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="mobile"
                        onChange={this.onChange}
                        value={this.state.mobile}
                      />
                      <div className="errStyle" style={{ float: "left" }}>
                        {this.state.mobileError}
                      </div>
                    </Form.Group>
                  </Col>
                </Row><br />

                <Row>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <Form.Group controlId="licence_num">
                      <Form.Label> Drug License(20B) </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="licenceNum"
                        onChange={this.onChange}
                        value={this.state.licencenum}
                      />
                      <div className="errStyle" style={{ float: "left" }}>
                        {this.state.licencenumError}
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <Form.Group controlId="licence_num2">
                      <Form.Label> Drug License(21B) </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="licenceNum2"
                        onChange={this.onChange}
                        value={this.state.licencenum2}
                      />
                      <div className="errStyle" style={{ float: "left" }}>
                        {this.state.licencenum2Error}
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <Form.Group controlId="gst">
                      <Form.Label> GSTIN </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="gstin"
                        onChange={this.onChange}
                        value={this.state.gst}
                      />
                      <div className="errStyle" style={{ float: "left" }}>
                        {this.state.gstError}
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <Form.Group controlId="credit">
                      <Form.Label>Credit Period</Form.Label>
                      <Form.Control
                        type="number"
                        autoComplete="off"
                        name="credit"
                        step={10}
                        min={0}
                        placeholder="0"
                        onChange={this.onChange}
                        value={this.state.credit}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <Form.Group controlId="contperson">
                      <Form.Label> Contact Person </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="contPerson"
                        onChange={this.onChange}
                        value={this.state.contPerson}
                      />
                      <div className="errStyle" style={{ float: "left" }}>
                        {this.state.contPersonError}
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                {/* <Row>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <Form.Group controlId="dlry">
                        <Form.Label>Store Delivery</Form.Label><br/>
                        <Form.Check inline label="Yes" type="radio" checked ={this.state.homedelivery===true} name="homedel" onChange={this.onChange}/>
                        <Form.Check inline label="No" type="radio" checked={this.state.homedelivery===false} name="homedel" onChange={this.onChange}/>
                      </Form.Group>
                  </Col>
                </Row> */}
              </Form>
            </Card.Body>

            <Card.Footer style={{ backgroundColor: "#fff" }}>
              <Button
                className="queryBtn1"
                onClick={this.gotoLocationpage}
                style={{ float: "right" }}
              >
                <span>Save and Proceed</span>
              </Button>
            </Card.Footer>
          </Card>
        </div>
        <div id="locationdiv" className="updateprofilediv">
          <Card className="updateprofilecard">
            <Card.Body>
              <Form>
                <Row>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <Form.Group controlId="addr1">
                      <Form.Label>Location</Form.Label>

                      <PlacesAutocomplete
                        value={this.state.location}
                        onChange={this.onLocationChange}
                        onSelect={this.handleSelect}
                        autoComplete="off"
                      >
                        {({
                          getInputProps,
                          suggestions,
                          getSuggestionItemProps,
                          loading
                        }) => (
                          <div>
                            <input
                              className="autocompleteInput"
                              {...getInputProps({
                                placeholder: "Type address"
                              })}
                            />

                            <div>
                              {loading ? <div>...loading</div> : null}

                              {suggestions.map(suggestion => {
                                const style = {
                                  backgroundColor: suggestion.active
                                    ? "#1768B7"
                                    : "#fff"
                                };

                                console.log(suggestions);

                                return (
                                  <div
                                    {...getSuggestionItemProps(suggestion, {
                                      style
                                    })}
                                  >
                                    {suggestion.description}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </PlacesAutocomplete>
                      <div className="errStyle">
                        {this.state.locationError}
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <Form.Group controlId="addr2">
                      <Form.Label> Address </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="addr2"
                        onChange={this.onChange}
                        value={this.state.addr2}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <Form.Group controlId="landmark">
                      <Form.Label> Landmark </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="landmark"
                        onChange={this.onChange}
                        value={this.state.landmark}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <Form.Group controlId="states">
                      <Form.Label>State</Form.Label>
                      <Form.Control
                        as="select"
                        name="states"
                        onChange={this.onChange}
                      >
                        <option value="">Select State</option>
                        {this.props.states &&
                          this.props.states.map((item, i) => (
                            <option key={i} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                      </Form.Control>
                      <div className="errStyle" style={{ float: "left" }}>
                        {this.state.statesError}
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <Form.Group controlId="district">
                      <Form.Label>District</Form.Label>
                      <Form.Control
                        as="select"
                        name="district"
                        defaultValue=""
                        onChange={this.onChange}
                      >
                        <option value="" selected>
                          Select District
                        </option>
                        {districtList &&
                          districtList.map((item, j) => (
                            <option key={j} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                      </Form.Control>
                      <div className="errStyle" style={{ float: "left" }}>
                        {this.state.districtError}
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <Form.Group controlId="city">
                      <Form.Label> City </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="city"
                        onChange={this.onChange}
                        value={this.state.city}
                      />
                      <div className="errStyle" style={{ float: "left" }}>
                        {this.state.cityError}
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <Form.Group controlId="zip">
                      <Form.Label> Pin Code </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="zip"
                        onChange={this.onChange}
                        value={this.state.zip}
                      />
                      <div className="errStyle" style={{ float: "left" }}>
                        {this.state.zipError}
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Card.Body>

            <Card.Footer style={{ backgroundColor: "#fff" }}>
              <Button
                className="queryBtn1"
                onClick={this.gotoWorkingdays}
                //onClick={this.gotoBanking}
                style={{ float: "right" }}
              >
                <span>Save and Proceed</span>
              </Button>
              <Button
                className="leftBtn"
                onClick={this.gotobusinesspage}
                style={{ float: "left" }}
              >
                <span>Previous page</span>
              </Button>
            </Card.Footer>
          </Card>
        </div>
        <div id="workingdiv">
          <Card className="updateprofilecard">
            <Card.Body>
              <Form>
                <Row>
                  <Table striped borderless hover size="sm">
                    <tr>
                      <th></th>
                      <th>Day</th>
                      <th>Opening Time</th>
                      <th>Closing Time</th>
                    </tr>
                    {Object.keys(this.state.workingHrs).map((item, i) => (
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            checked={this.state.workingHrs[item].isWorking}
                            onClick={e => this.oncheckChange(e, item)}
                          />
                        </td>
                        <td>{this.state.workingHrs[item].showDay}</td>
                        <td>
                          <TimePicker
                            format="hh:mm a"
                            clockIcon={null}
                            disableClock={true}
                            clearIcon={null}
                            value={this.state.workingHrs[item].open}
                            onChange={e =>
                              this.ontimeChange(e, item, "open", "openmin")
                            }
                          />
                        </td>
                        <td>
                          <TimePicker
                            format="hh:mm a"
                            clockIcon={null}
                            disableClock={true}
                            clearIcon={null}
                            value={this.state.workingHrs[item].close}
                            onChange={e =>
                              this.ontimeChange(e, item, "close", "closemin")
                            }
                          />
                        </td>
                      </tr>
                    ))}
                  </Table>
                </Row>
              </Form>
            </Card.Body>
            <Card.Footer style={{ backgroundColor: "#fff" }}>
              <Button
                className="queryBtn1"
                onClick={this.gotoBanking}
                style={{ float: "right" }}
              >
                <span>Save and Proceed</span>
              </Button>
              <Button
                className="leftBtn"
                onClick={this.gotoLocationpage}
                style={{ float: "left" }}
              >
                <span>Previous page</span>
              </Button>
            </Card.Footer>
          </Card>
        </div>
        <div id="bankdiv">
          <Card className="updateprofilecard">
            <Card.Body>
              <Form>
                <Row>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <Form.Group controlId="banks">
                      <Form.Label>Select your bank</Form.Label>
                      <Form.Control
                        as="select"
                        name="banks"
                        onChange={this.onChange}
                      >
                        <option value="">Select</option>
                        {this.props.banks &&
                          this.props.banks.map((item, i) => (
                            <option key={i} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                      </Form.Control>
                      <div className="errStyle" style={{ float: "left" }}>
                        {this.state.bankNameError}
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <Form.Group controlId="acholderName">
                      <Form.Label> Account Holder Name </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="acholderName"
                        onChange={this.onChange}
                        value={this.state.acholderName}
                      />
                      <div className="errStyle" style={{ float: "left" }}>
                        {this.state.acholderNameError}
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <Form.Group controlId="actype">
                      <Form.Label> Account Type </Form.Label>
                      <Form.Control
                        as="select"
                        name="actype"
                        onChange={this.onChange}
                      >
                        <option value="">Select</option>
                        <option value="saving">Savings</option>
                        <option value="current">Current</option>
                      </Form.Control>
                      <div className="errStyle" style={{ float: "left" }}>
                        {this.state.acTypeError}
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <Form.Group controlId="acno">
                      <Form.Label>Account No</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="acno"
                        onChange={this.onChange}
                        value={this.state.acNo}
                      />
                      <div className="errStyle" style={{ float: "left" }}>
                        {this.state.acNoError}
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <Form.Group controlId="ifsc">
                      <Form.Label>IFSC</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="ifsc"
                        onChange={this.onChange}
                        value={this.state.ifsc}
                      />
                      <div className="errStyle" style={{ float: "left" }}>
                        {this.state.ifscError}
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <Form.Group controlId="branchname">
                      <Form.Label> Branch Name </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="branchname"
                        onChange={this.onChange}
                        value={this.state.branchName}
                      />
                      <div className="errStyle" style={{ float: "left" }}>
                        {this.state.branchNameError}
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <Form.Group controlId="branchaddr">
                      <Form.Label> Branch Address </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="branchaddr"
                        onChange={this.onChange}
                        value={this.state.branchAddr}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Card.Body>

            <Card.Footer style={{ backgroundColor: "#fff" }}>
              <Button
                className="queryBtn1"
                onClick={this.updateprofilevalues}
                style={{ float: "right" }}
              >
                Submit
              </Button>
              <Button
                className="leftBtn"
                //onClick={this.gotoWorkingdays}
                onClick={this.gotoWorkingdays}
                style={{ float: "left" }}
              >
                <span>Previous page</span>
              </Button>
            </Card.Footer>
          </Card>
        </div>
      </div>
    );
  }
}

/* export default GoogleApiWrapper({
  apiKey: 'AIzaSyCn8jkXfj8QyH4enxIOVmwlhFIofAiQpJs'
})(UpdateProfile);  */

export default UpdateProfile;
